import React from 'react';

import { View, Image, StyleSheet } from "@react-pdf/renderer";

import "./index.scss"

export function FooterBackgroundPdf({ background }) {

    return (
        <View style={styles.footerBackground}>
            {background ?
                <Image style={styles.footerBackground} src={background} />
                :
                <View style={styles.footerBackground} />
            }
        </View>
    )
}

export function FooterBackground({ background }) {

    return (
        <div className="footerBackground">
            {background ?
                <img className="footerBackground" src={background} alt='img' />
                :
                <div className="footerBackground">
                </div>
            }
        </div>
    )
}

const styles = StyleSheet.create({
    footerBackground: {
        width: '100%',
        height: '100%'
    },
})